import { render, staticRenderFns } from "./outboundTasksDetail.vue?vue&type=template&id=dad49d5c&scoped=true&"
import script from "./outboundTasksDetail.vue?vue&type=script&lang=js&"
export * from "./outboundTasksDetail.vue?vue&type=script&lang=js&"
import style0 from "./outboundTasksDetail.vue?vue&type=style&index=0&id=dad49d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad49d5c",
  null
  
)

export default component.exports